// extracted by mini-css-extract-plugin
export default {"root":"KjdI2hvLtU4Qa072xQ2y","option":"VJl0gJK_tpEvmB7Tdkrl"};